import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { tap, switchMap, catchError, distinctUntilChanged } from 'rxjs/operators';

import * as fromStore from '@unico-people/shared/dashboard/data-access-store';
import { getTokenStorage } from '@unico-people/shared/utils/storage';

@Injectable()
export class OrganizationGuard implements CanActivate {
  constructor(private store: Store<fromStore.DashboardState>) {}

  canActivate(): Observable<any> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.pipe(
      select(fromStore.getOrganizationLoaded),
      tap(loaded => {
        if (!loaded) {
          this.store.dispatch(fromStore.loadOrganization(getTokenStorage()));
        }
      }),
      distinctUntilChanged()
    );
  }
}
